import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import BookingPage from "./pages/BookingPage";
import WinterCampBookingPage from "./pages/WinterCampBookingPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/book" replace />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/winter-camp-booking" element={<WinterCampBookingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
